<script setup lang="ts">
/**
 * Entry page for the flow
 * --------------------------------------------------------------------------------------------------
 * This page is SERVER-SIDE-RENDERED and serves as a fast-loaded entry point
 * to the product flow. it resets all stores.
 */
definePageMeta({
    layout: 'empty',
    path: '/booking/unlimited-pass-summer/start',
    title: 'offerFlow.splashMessage.unlimited-pass-summer',
});

onMounted(() => {
    useResetStores().resetOfferFlow();
    useStartFreshFlow().startFreshFlow(productConfigUnlimitedPassSummer);
});
</script>

<template>
    <IntroLoader />
</template>
